import { useMutation, useQuery, useQueryClient } from "react-query";
import { deliveryIssueApi } from "../api/delivery-issue-api";
import {
  CreateDeliveryIssuePayload,
  UpdateDeliveryIssuePayload,
} from "../types/delivery-issue/delivery-issue";

export enum DeliveryIssueQueryKey {
  ListByDelivery = "DeliveryIssueListByDelivery",
}

export const useDeliveryIssueListQuery = (
  deliveryId: string | null,
  enabled = true,
) =>
  useQuery(
    [DeliveryIssueQueryKey.ListByDelivery, deliveryId],
    () => deliveryIssueApi.listByDelivery(deliveryId!),
    { enabled: enabled && !!deliveryId },
  );

export const useCreateDeliveryIssueMutation = (deliveryId: string | null) => {
  const queryClient = useQueryClient();
  return useMutation(
    (payload: CreateDeliveryIssuePayload) => deliveryIssueApi.create(payload),
    {
      onSuccess: () => {
        if (deliveryId) {
          queryClient.invalidateQueries([
            DeliveryIssueQueryKey.ListByDelivery,
            deliveryId,
          ]);
        }
      },
    },
  );
};

export const useUpdateDeliveryIssueMutation = (deliveryId: string | null) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, payload }: { id: string; payload: UpdateDeliveryIssuePayload }) =>
      deliveryIssueApi.update(id, payload),
    {
      onSuccess: () => {
        if (deliveryId) {
          queryClient.invalidateQueries([
            DeliveryIssueQueryKey.ListByDelivery,
            deliveryId,
          ]);
        }
      },
    },
  );
};

export const useDeleteDeliveryIssueMutation = (deliveryId: string | null) => {
  const queryClient = useQueryClient();
  return useMutation((id: string) => deliveryIssueApi.delete(id), {
    onSuccess: () => {
      if (deliveryId) {
        queryClient.invalidateQueries([
          DeliveryIssueQueryKey.ListByDelivery,
          deliveryId,
        ]);
      }
    },
  });
};
